import { render } from "./HermesRolesList.vue?vue&type=template&id=4afd36c0&scoped=true"
import script from "./HermesRolesList.vue?vue&type=script&lang=js"
export * from "./HermesRolesList.vue?vue&type=script&lang=js"

import "./HermesRolesList.vue?vue&type=style&index=0&id=4afd36c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4afd36c0"]])

export default __exports__